"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUploadRepository = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const AWS = tslib_1.__importStar(require("aws-sdk"));
const typeorm_2 = require("typeorm");
const file_upload_entity_1 = require("../../../../service-lib/src/lib/entities/file-upload.entity");
const archived_file_upload_entity_1 = require("../../../../service-lib/src/lib/entities/archived-file-upload.entity");
const company_entity_1 = require("../../../../service-lib/src/lib/entities/company.entity");
let FileUploadRepository = class FileUploadRepository {
    constructor(fileUploadRepository, companyRepository, archivedFileUploadRepository) {
        this.fileUploadRepository = fileUploadRepository;
        this.companyRepository = companyRepository;
        this.archivedFileUploadRepository = archivedFileUploadRepository;
        this.bucket = process.env.S3_AWS_BUCKET || "";
        this.docRepoPath = process.env.DOCUMENT_REPOSITORY || "tmp/document-repository";
        this.repoMode = process.env.DOCUMENT_REPOSITORY_MODE || "LFS";
        this.initialized = false;
        if (this.repoMode === "AWS") {
            try {
                AWS.config.update({
                    // accessKeyId: process.env.S3_AWS_ACCESS_KEY_ID,
                    // secretAccessKey: process.env.S3_AWS_SECRET_ACCESS_KEY,
                    region: process.env.S3_AWS_REGION,
                });
                this.s3 = new AWS.S3();
                this.initialized = true;
            }
            catch (err) {
                console.error("AWS initialization failed:", err);
                this.initialized = false;
            }
        }
        else {
            const fs = require("fs");
            try {
                if (fs.existsSync(this.docRepoPath) &&
                    fs.statSync(this.docRepoPath).isDirectory()) {
                    this.initialized = true;
                }
                else {
                    console.error(`Local repository path invalid: ${this.docRepoPath}`);
                    this.initialized = false;
                }
            }
            catch (err) {
                console.error("Local repository check failed:", err);
                this.initialized = false;
            }
        }
    }
    /**
     * Uploads a file using the specified upload strategy.
     */
    async uploadFile(file, companyType, companyId, documentTypeLid, userId) {
        try {
            if (!this.initialized) {
                throw new Error("Document repository is not initialized. Cannot create file entry.");
            }
            const sanitizedFileName = file.originalname.replace(/\s+/g, "");
            const fileName = `${Date.now()}_${sanitizedFileName}`;
            const key = `uploads/company/${companyType}/${fileName}`;
            let relativePath = key;
            if (this.repoMode === "AWS") {
                const uploadResult = await this.s3
                    .putObject({ Bucket: this.bucket, Key: key, Body: file.buffer })
                    .promise();
                if (!uploadResult || uploadResult.$response.error) {
                    throw new Error("File upload to S3 failed.");
                }
            }
            else {
                const fs = require("fs");
                const path = require("path");
                const fullDirPath = path.join(this.docRepoPath, relativePath);
                const fullFilePath = path.join(fullDirPath, fileName);
                // Ensure directory exists
                try {
                    fs.mkdirSync(fullDirPath, { recursive: true });
                }
                catch (mkdirErr) {
                    console.error("Failed to create directory:", mkdirErr);
                }
                // Write file
                try {
                    fs.writeFileSync(fullFilePath, file.buffer);
                }
                catch (writeErr) {
                    console.error("Failed to write file:", writeErr);
                }
                return fileName;
            }
            const s3Url = `https://${this.bucket}.s3.${process.env.S3_AWS_REGION}.amazonaws.com/${key}`;
            relativePath = s3Url; // Save the full S3 URL in the database
            const fileUpload = this.fileUploadRepository.create({
                fileKey: key,
                companyType: companyType,
                companyId,
                uploadType: "AWS",
                documentTypeLid: documentTypeLid,
                createdAt: new Date(),
                updatedAt: new Date(),
                createdBy: userId,
                updatedBy: userId,
                deletedAt: null,
            });
            const savedFile = await this.fileUploadRepository.save(fileUpload);
            if (!savedFile || !savedFile.id) {
                throw new common_1.InternalServerErrorException("File metadata not saved");
            }
            const uploadedFile = {
                id: savedFile.id,
                fileKey: savedFile.fileKey,
                fileName: fileName,
                companyType: savedFile.companyType,
                companyId: savedFile.companyId,
                documentTypeLid: savedFile.documentTypeLid,
                fileBuffer: file.buffer.toString("base64"),
            };
            return {
                status: common_1.HttpStatus.OK,
                message: "File uploaded successfully",
                data: uploadedFile,
            };
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException ||
                error instanceof common_1.BadRequestException) {
                throw error;
            }
            else {
                throw new common_1.InternalServerErrorException("File upload failed");
            }
        }
    }
    /**
     * Replaces a file on the local server in a type-based and company-based directory structure.
  //    */
    async replaceFileFromServer(id, file, userId, body) {
        try {
            const fileUpload = await this.fileUploadRepository.findOne({
                where: { id },
            });
            if (!fileUpload) {
                throw new common_1.NotFoundException("File not found");
            }
            const oldFileKey = fileUpload.fileKey;
            // Remove spaces from the original file name
            const sanitizedFileName = file.originalname.replace(/\s+/g, "");
            const newFileName = `${Date.now()}_${sanitizedFileName}`;
            const newFileKey = `uploads/company/${body?.companyType}/${newFileName}`;
            const archivedKey = `uploads/company/archived/${fileUpload.companyType}/${oldFileKey.split("/").pop()}`;
            if (this.repoMode === "AWS") {
                const encodedCopySource = encodeURIComponent(`${this.bucket}/${oldFileKey}`);
                const res = await this.s3
                    .copyObject({
                    Bucket: this.bucket,
                    CopySource: encodedCopySource,
                    Key: archivedKey,
                })
                    .promise();
                if (res &&
                    res.$response &&
                    res.$response.httpResponse.statusCode === 200) {
                    await this.s3
                        .deleteObject({ Bucket: this.bucket, Key: oldFileKey })
                        .promise();
                }
                else {
                    console.error("Failed to archive old file in S3:", res.$response.error);
                    throw new common_1.InternalServerErrorException("Failed to archive old file");
                }
                await this.s3
                    .putObject({
                    Bucket: this.bucket,
                    Key: newFileKey,
                    Body: file.buffer,
                    ContentType: file.mimetype,
                })
                    .promise();
            }
            else {
                const fs = require("fs");
                const path = require("path");
                const fullDirPath = path.join(this.docRepoPath, key.split("/").slice(0, -1).join("/"));
                const fullFilePath = path.join(fullDirPath, fileName);
                // Ensure directory exists
                try {
                    fs.mkdirSync(fullDirPath, { recursive: true });
                }
                catch (mkdirErr) {
                    console.error("Failed to create directory:", mkdirErr);
                }
                // Write file
                try {
                    fs.writeFileSync(fullFilePath, file.buffer);
                }
                catch (writeErr) {
                    console.error("Failed to write file:", writeErr);
                }
            }
            // const s3Url = this.s3.getSignedUrl("getObject", {
            //   Bucket: this.bucket,
            //   Key: newFileKey,
            //   Expires: 3600, // URL expiration time in seconds
            // });
            // Archive the existing file details
            const archivedFile = this.archivedFileUploadRepository.create({
                refFileUploadId: fileUpload.id,
                fileKey: fileUpload.fileKey,
                newFileKey: archivedKey, // Store the old file key as newFileKey
                companyType: fileUpload.companyType,
                companyId: fileUpload.companyId,
                uploadType: fileUpload.uploadType,
                documentTypeLid: fileUpload.documentTypeLid,
                createdBy: fileUpload.createdBy,
                updatedBy: userId,
                deletedAt: new Date(),
            });
            await this.archivedFileUploadRepository.save(archivedFile);
            fileUpload.fileKey = newFileKey;
            fileUpload.updatedBy = userId;
            fileUpload.documentTypeLid =
                body?.documentTypeLid || fileUpload.documentTypeLid;
            fileUpload.companyType = body?.companyType || fileUpload.companyType;
            fileUpload.companyId = body?.companyId || fileUpload.companyId;
            const updatedFileUpload = await this.fileUploadRepository.save(fileUpload);
            if (!updatedFileUpload.id) {
                throw new common_1.InternalServerErrorException("Failed to update file in DB");
            }
            const fileReplacedData = {
                id: updatedFileUpload.id,
                companyType: updatedFileUpload.companyType,
                companyId: updatedFileUpload.companyId,
                fileKey: updatedFileUpload.fileKey,
                fileName: newFileName,
                documentTypeLid: updatedFileUpload.documentTypeLid,
                fileBuffer: file.buffer.toString("base64"),
            };
            return {
                status: common_1.HttpStatus.OK,
                message: "File replaced successfully",
                data: fileReplacedData,
            };
        }
        catch (error) {
            throw new common_1.BadRequestException(error instanceof Error
                ? error.message
                : `Error replacing file: ${file.originalname}`);
        }
    }
    async getCompanyNameById(id) {
        const company = await this.companyRepository.findOne({
            where: { id },
        });
        if (!company) {
            throw new common_1.NotFoundException("Company not found");
        }
        return company.displayName;
    }
    async deleteFileFromServer(fileId, userId) {
        try {
            const fileUpload = await this.fileUploadRepository.findOne({
                where: { id: fileId },
            });
            if (!fileUpload) {
                throw new common_1.NotFoundException("File not found");
            }
            const oldFileKey = fileUpload.fileKey;
            const archivedKey = `uploads/company/archived/${fileUpload.companyType}/${oldFileKey.split("/").pop()}`;
            if (this.repoMode === "AWS") {
                const encodedCopySource = encodeURIComponent(`${this.bucket}/${oldFileKey}`);
                const res = await this.s3
                    .copyObject({
                    Bucket: this.bucket,
                    CopySource: encodedCopySource,
                    Key: archivedKey,
                })
                    .promise();
                if (res &&
                    res.$response &&
                    res.$response.httpResponse.statusCode === 200) {
                    await this.s3
                        .deleteObject({ Bucket: this.bucket, Key: oldFileKey })
                        .promise();
                }
                else {
                    throw new common_1.InternalServerErrorException("Failed to archive file");
                }
            }
            else {
                const fs = require("fs");
                const path = require("path");
                const oldFilePath = path.join(this.docRepoPath, oldFileKey);
                const archivedFilePath = path.join(this.docRepoPath, archivedKey);
                if (fs.existsSync(oldFilePath)) {
                    fs.mkdirSync(path.dirname(archivedFilePath), { recursive: true });
                    fs.renameSync(oldFilePath, archivedFilePath);
                }
                else {
                    throw new common_1.NotFoundException("File not found on disk");
                }
            }
            console.log("Inserting deleted file details into archived table");
            const archivedFile = this.archivedFileUploadRepository.create({
                refFileUploadId: fileUpload.id,
                fileKey: oldFileKey,
                newFileKey: archivedKey,
                companyType: fileUpload.companyType,
                companyId: fileUpload.companyId,
                uploadType: fileUpload.uploadType,
                documentTypeLid: fileUpload.documentTypeLid,
                createdBy: fileUpload.createdBy,
                updatedBy: userId,
                deletedAt: new Date(),
            });
            await this.archivedFileUploadRepository.save(archivedFile);
            await this.fileUploadRepository.update(fileId, { deletedAt: new Date() });
            const data = {
                id: fileId,
                companyType: fileUpload.companyType,
                companyId: fileUpload.companyId,
                documentTypeLid: fileUpload.documentTypeLid,
                fileKey: oldFileKey,
                archivedKey,
            };
            return {
                status: common_1.HttpStatus.OK,
                message: "File deleted successfully",
                data,
            };
        }
        catch (error) {
            console.error("Error deleting file:", error);
            throw error;
        }
    }
    async getFileStream(key) {
        // Validation for required field
        if (!key || typeof key !== "string" || !key.trim()) {
            throw new Error("File key is required.");
        }
        if (this.repoMode === "AWS") {
            // Fetch the file and its metadata from S3
            const params = { Bucket: this.bucket, Key: key };
            try {
                const head = await this.s3.headObject(params).promise();
                const s3Stream = await this.s3.getObject(params).createReadStream();
                return {
                    stream: s3Stream,
                    mimeType: head.ContentType,
                    contentLength: head.ContentLength,
                };
            }
            catch (err) {
                console.error("S3 file fetch error:", err); // log this
                throw new Error("File not found in S3.");
            }
        }
        else {
            // Read the file from the local filesystem (LFS)
            const fs = require("fs");
            const path = require("path");
            const fullFilePath = path.join(this.docRepoPath, key);
            if (!fs.existsSync(fullFilePath)) {
                throw new Error("File not found in local storage");
            }
            const localStream = fs.createReadStream(fullFilePath);
            const mime = require("mime-types");
            const mimeType = mime.lookup(fullFilePath) || "application/octet-stream";
            const contentLength = fs.statSync(fullFilePath).size;
            return {
                stream: localStream,
                mimeType,
                contentLength,
            };
        }
    }
    async findDocuments(documentId) {
        try {
            const fileUpload = await this.fileUploadRepository.findOne({
                where: { id: documentId },
            });
            console.log("Retrieved file upload:", fileUpload);
            if (!fileUpload) {
                throw new common_1.NotFoundException("Document not found");
            }
            return fileUpload;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error;
            }
            else {
                console.error("Error retrieving document:", error);
                throw new common_1.InternalServerErrorException("Failed to retrieve document");
            }
        }
    }
};
exports.FileUploadRepository = FileUploadRepository;
exports.FileUploadRepository = FileUploadRepository = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__param(0, (0, typeorm_1.InjectRepository)(file_upload_entity_1.FileUpload)),
    tslib_1.__param(1, (0, typeorm_1.InjectRepository)(company_entity_1.Company)),
    tslib_1.__param(2, (0, typeorm_1.InjectRepository)(archived_file_upload_entity_1.ArchivedFileUpload)),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _a : Object, typeof (_b = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _b : Object, typeof (_c = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _c : Object])
], FileUploadRepository);
